import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  background-color: #085cac;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 25px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 50px;
  font-size: 20px;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  flex: 1;

  img {
    height: 40px;
    width: auto;
    margin-right: 10px;
  }

  .logo-text {
    font-size: 24px;
    color: #fff;
    font-weight: bold;
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10%;
  flex: 1;

  a {
    color: #fff;
    margin-left: 15px;
    text-decoration: none;
    font-weight: bold;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const Hamburger = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;

  span {
    height: 3px;
    width: 25px;
    background-color: #fff;
    margin: 4px;
    border-radius: 5px;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

const SideMenu = styled.div`
  position: fixed;
  top: 0;
  right: ${(props) => (props.isOpen ? '0' : '-100%')};
  width: 200px;
  height: 100%;
  background-color: #085cac;
  display: flex;
  flex-direction: column;
  align-items: left;
  padding-left: 10px;
  justify-content: center;
  transition: right 0.3s ease;
  z-index: 999;

  a {
    color: #fff;
    margin-bottom: 15px;
    text-decoration: none;
    font-size: 24px;
    font-weight: bold;
  }

  @media (min-width: 769px) {
    display: none;
  }
`;

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <HeaderContainer>
        <Logo>
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo" />
        </Logo>
        <Nav>
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/resources">Resources</Link>
          <Link to="/events">Events</Link>
          <Link to="/gallery">Gallery</Link>
        </Nav>
        <Hamburger onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </Hamburger>
      </HeaderContainer>

      <SideMenu isOpen={isOpen}>
        <Link to="/" onClick={toggleMenu}>Home</Link>
        <Link to="/about" onClick={toggleMenu}>About</Link>
        <Link to="/resources" onClick={toggleMenu}>Resources</Link>
        <Link to="/events" onClick={toggleMenu}>Events</Link>
        <Link to="/gallery" onClick={toggleMenu}>Gallery</Link>
      </SideMenu>
    </>
  );
};

export default Header;
